import styled from "styled-components";

export const FormFieldContainer = styled.div`
  margin-bottom: 1.5rem;
  max-width: 100%;

  & .p-inputtext:enabled:focus ~ label {
    color: #333;
    font-size: 1em;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
